import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/** The row under a patient list's toolbar that insets its cards from the sunken page. */
export const ListPane = styled(Box)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    minHeight: 0,
    padding: theme.spacing(2.5, 3.5, 3),
}));

/** The bordered card a patient list's rows sit on. */
export const ListSurface = styled(Box)(({ theme }) => ({
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    overflow: 'hidden',
}));
